module.exports = __webpack_public_path__ + "img/my-image (1).86c701d6.png";